<script setup>
import { useI18n } from 'vue-i18n';
import Switch from 'dashboard/components-next/switch/Switch.vue';

defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  compact: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['change']);

const modelValue = defineModel({
  type: Boolean,
  default: false,
});

const { t } = useI18n();
</script>

<template>
  <div
    data-testid="shared-card-automation-opt-in"
    class="rounded-xl border border-n-weak bg-n-solid-1"
    :class="compact ? 'p-2.5' : 'p-3'"
  >
    <div class="flex items-start justify-between gap-3">
      <div class="min-w-0">
        <p class="m-0 text-sm font-medium text-n-slate-12">
          {{ t('KANBAN_SHARING.AUTOMATIONS.TITLE') }}
        </p>
        <p class="mb-0 mt-1 text-xs leading-5 text-n-slate-11">
          {{ t('KANBAN_SHARING.AUTOMATIONS.DESCRIPTION') }}
        </p>
      </div>
      <Switch
        v-model="modelValue"
        :disabled="disabled"
        :aria-label="t('KANBAN_SHARING.AUTOMATIONS.TITLE')"
        @change="emit('change', $event)"
      />
    </div>
    <p
      v-if="modelValue"
      class="mb-0 mt-2 text-xs font-medium text-n-amber-11"
      role="status"
    >
      {{ t('KANBAN_SHARING.AUTOMATIONS.ENABLED_NOTICE') }}
    </p>
  </div>
</template>
